// Import the functions needed from SDKs needed
import { initializeApp } from "firebase/app";

import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';

import {
  getDocs,
  query,
  where,
  collection,
  getFirestore,
  getDoc,
  doc,
  setDoc
} from 'firebase/firestore';

import {
  getDownloadURL,
  getStorage, ref
} from 'firebase/storage';

import {
  getFunctions,
  httpsCallable
} from 'firebase/functions';


// The Shoru server's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAHhdiXJ6Ly1q2Vd1R_FmTkPIy50wUoQGo",
  authDomain: "shoru-ed7ff.firebaseapp.com",
  projectId: "shoru-ed7ff",
  storageBucket: "shoru-ed7ff.appspot.com",
  messagingSenderId: "934054380023",
  appId: "1:934054380023:web:c5a1cd6ce0bf7543e1eef2",
  measurementId: "G-MV89L50T4C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);





/* 
  AUTHENTICATION FUNCTIONS 
*/

// Attempts to sign the user in using email and password
const logInWithEmailAndPassword = async (email, password, setWorking, setFailureMessage) => {
  try {
    setWorking(true);
    await signInWithEmailAndPassword(auth, email, password);
    return true;
  }
  catch(err)
  {
    console.error(err);
    setFailureMessage("Email or password is incorrect");
    setWorking(false);
    return false;
  }
};

// Logs the current user out
const logout = async(redirect=true) => {
  await signOut(auth);
  if(redirect) {
    window.location.replace('/login');
  }
};

// Sends a reset password email
const sendPasswordReset = async (email, setWorking, setFailureMessage, setSuccessMessage) => {
  try {
    setWorking(true);
    await sendPasswordResetEmail(auth, email);
    setFailureMessage('');
    setSuccessMessage("A password reset link has been sent to the email provided. Check your spam folder if it does not appear!");
  } catch (err) {
    console.error(err);
    setSuccessMessage('');
    setFailureMessage("We couldn't find an account associated with that email. Your account may be registered under another email, or it may have been deleted. Contact DramaSoc for more support.");
  }
  finally {
    setWorking(false);
  }
};

const handleUserAuth = async(setUserData, setProjectData, setExtraData, setOrganisationData, extraDataDocName, isAdminPage) => {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if(user)
    {
      getUserData(user, setUserData, setProjectData, setExtraData, setOrganisationData, extraDataDocName, isAdminPage);
    }
    else {
      window.location.replace('/login');
    }
  })
}





/*
 * DATA FETCH OPERATIONS
 */

// Gets user data
/**
 * 
 * @param {*} user 
 * @param {*} setUserData 
 * @param {*} setProjectData - Sets to 'false' if no project for current user exists
 * @param {*} setExtraData - Sets to 'false' if no project for current user exists
 * @param {*} setOrganisationData 
 * @param {*} appName 
 * @param {*} isAdminPage 
 * @returns 
 */
const getUserData = async(user, setUserData, setProjectData, setExtraData, setOrganisationData, appName, isAdminPage) => {
  try {
    const q = query(collection(db, 'users'), where('uid', '==', user.uid));
    const qDoc = await getDocs(q);
    const data = qDoc.docs[0].data();
    const organisation = data.active_organisation_id;

    // Get admin and project information
    var isAdmin = false;
    var project = null;
    data.organisations.forEach((o) => {
      if(o.id === organisation) {
        isAdmin = o.admin;
        project = o.active_project_id;
      }
    })

    if(isAdmin || !isAdminPage) setUserData(data);
    else if(isAdminPage) {
      alert('You lack the admin permissions to view this page!')
      window.location.replace('/');
      return;
    }

    // Safety check, if the organisation isn't found.
    if((organisation === null || project === null) && !isAdminPage) { 
      setProjectData(false)
      setExtraData(false)
    }
    else if(organisation) {
      if(isAdminPage)
      {
        // Get all project data
        await getAllDataFrom(organisation, 'project-data', 'projects', setProjectData);
        // Get all extra data (e.g. castingbot data)
        await getAllDataFrom(organisation, appName, 'projects', setExtraData);
      }
      else
      {
        // Get and set project data
        await _getData(organisation, 'project-data', project, setProjectData);
        // Get and set extra data (e.g. castingbot data)
        await _getData(organisation, appName, project, setExtraData);
      }
    }

    if(organisation) {
      // Get organisation data
      await getOrganisationData(organisation, setOrganisationData);
    }
    else {
      setOrganisationData(false);
    }
  } 
  catch (err) 
  {
    console.error(err);
    alert(err);
    //logout();
  };
};

const getProjectData = async(organisation, project, setProjectData) => {
  await _getData(organisation, 'project-data', project, setProjectData);
}

const getExtraData = async(appName, organisation, project, setExtraData) => {
  await _getData(organisation, appName, project, setExtraData);
}

const getOrganisationData = async(organisation, setOrganisationData) => {
  const docRef = doc(db, organisation, 'organisation-data');
  try {
    const qDoc = await getDoc(docRef);
    const data = qDoc.data();
    setOrganisationData(data);
  } 
  catch (err) 
  {
    console.error(err);
    alert(err);
    logout();
  };
}

const getAllDataFrom = async(organisation, document, subCollection, setData) => {
  try {
    const collectionRef = collection(db, organisation, document, subCollection);
    const qDocs = await getDocs(collectionRef);
    var data = [];
    qDocs.forEach((item) => {data.push(item.data())})
    setData(data);
  }
  catch(err) {
    console.error(err);
    alert(err);
    logout();
  }
}

const _getData = async(organisation, document, project, setData) => {
  try {
    const docRef = doc(db, organisation, document, 'projects', project);
    const qDoc = await getDoc(docRef);
    const data = qDoc.data();
    setData(data);
  } 
  catch (err) 
  {
    console.error(err);
    alert(err);
    logout();
  };
}





/**
 * DATA SET OPERATIONS
 */

// Does not handle state setting
const setActiveOrganisation = async(organisation, userData) => {
  const docRef = doc(db, 'users', userData.uid);
  await setDoc(docRef, {active_organisation_id: organisation}, {merge: true});
}

// Does not handle state setting
const setActiveProject = async(organisation, project, userData) => {
  const newOrganisations = userData.organisations.map((x) => {
    if(x.id === organisation) { x.active_project_id = project; }
    return x;
  })
  const docRef = doc(db, 'users', userData.uid);
  await setDoc(docRef, {organisations: newOrganisations}, {merge: true});
}






/*
 * STORAGE OPERATIONS
 */

const getOrganisationAndProjectLogos = async(organisationId, projectId, setOrganisationLogo, setProjectLogo) => {
  await getOrganisationLogo(organisationId, setOrganisationLogo);
  await getProjectLogo(organisationId, projectId, setProjectLogo);
}

const getOrganisationLogo = async(organisationId, setOrganisationLogo) => {
  const logoRef = ref(storage, (organisationId + '/organisation/logo-square.png'));
  try {
    getDownloadURL(logoRef)
    .then((url) => {
      setOrganisationLogo(url);
    })
    .catch((err) => {
      console.error(err);
    })
  }
  catch(err) {
    // Print error, but no further action required (logo may not exist)
    console.error(err);
  }
}

const getProjectLogo = async(organisationId, projectId, setProjectLogo) => {
  const logoRef = ref(storage, (organisationId + '/projects/' + projectId + '/logo-square.png'));
  try {
    getDownloadURL(logoRef)
    .then((url) => {
      setProjectLogo(url);
    })
    .catch((err) => {
      console.error(err);
    })
  }
  catch(err) {
    // Print error, but no further action required (logo may not exist)
    console.error(err);
  }
}




/*
  EXPORT
*/

export {
  auth,
  db,
  functions,

  logInWithEmailAndPassword,
  logout,
  sendPasswordReset,
  handleUserAuth,

  getProjectData,
  getExtraData,
  getOrganisationData,
  getAllDataFrom,

  setActiveOrganisation,
  setActiveProject,

  getOrganisationAndProjectLogos,
  getOrganisationLogo,
  getProjectLogo
}